import React from 'react';

function AnimatedHeaderLogo() {
  return (
    <div className="header-logo" aria-label="Deepmind">
      <span className="header-logo-mark" aria-hidden="true">
        <svg viewBox="0 0 28 28" role="img">
          <rect x="4" y="3" width="20" height="22" rx="5" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M9 10h10M9 14h10M9 18h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
      <span className="header-logo-text">Deepmind</span>
    </div>
  );
}

export default AnimatedHeaderLogo;
